import Vue from 'vue'
// 创建一个空Vue实例作为总线
export const bus = new Vue()